import { useEffect } from 'react'
import { useAppStore, useFilterStore } from '@/shared/store'
import { getTranslationsForAllLanguages } from '@/shared/lib'

interface Translations {
    [key: string]: string
}

export const useSetCategoryIfAllGenres = () => {
    const { setActualCategory, actualCategory, filterCategories } =
        useFilterStore()
    const { actualProfile } = useAppStore()

    useEffect(() => {
        function findCategory(translations: Translations) {
            for (const category of filterCategories) {
                for (const key in translations) {
                    if (
                        category.name ===
                        translations[key as keyof Translations]
                    ) {
                        return category
                    }
                }
            }
            return null
        }

        if (filterCategories.length && !actualCategory) {
            const allTranslationsGenreAll =
                getTranslationsForAllLanguages('genreAll')

            const isAllGenres = findCategory(allTranslationsGenreAll)
            if (isAllGenres) {
                setActualCategory(isAllGenres)
            }
        }
    }, [
        filterCategories.length,
        actualProfile?.id,
        actualCategory,
        setActualCategory,
        getTranslationsForAllLanguages,
    ])
}
